import React from 'react'
import {
  FormControlLabel,
  Switch as MuiSwitch,
  SwitchProps as MuiSwitchProps,
} from '@material-ui/core'

export type SwitchProps = MuiSwitchProps & {
  label?: string
}

export function Switch(props: SwitchProps): React.ReactElement {
  const { label, ...switchProps } = props

  if (!label) {
    return <MuiSwitch {...switchProps} />
  }

  return (
    <FormControlLabel control={<MuiSwitch {...switchProps} />} label={label} />
  )
}
